type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const VendorType = Object.freeze({
  INDIVIDUAL: 1 as const,
  COMPANY: 2 as const,
});

export type VendorType = EnumLiteralsOf<typeof VendorType>;
